import React, { useState } from 'react'
import { DatePicker, Form, Select, TimePicker } from 'antd'

interface CustomTimeProps {
  setIsCustomTime: React.Dispatch<React.SetStateAction<boolean>>
}

const CustomTime: React.FC<CustomTimeProps> = ({ setIsCustomTime }) => {
  const hanldeChange = (value: string) => {
    if (value === 'customTimeToSend') {
      setIsCustomTime(true)
    } else {
      setIsCustomTime(false)
    }
  }
  return (
    <div className="flex gap-16px align-center w-full">
      <div style={{ width: '35%' }}>
        <Form.Item name="date">
          <DatePicker
            className="w-100 form-control-field"
            placeholder="Date"
            // disabledDate={}
          />
        </Form.Item>
      </div>

      <div style={{ width: '35%' }}>
        <Form.Item name="time">
          <TimePicker
            format={'hh:mm a'}
            className="w-100 form-control-field"
            placeholder="Time"
          />
        </Form.Item>
      </div>

      <div style={{ width: '30%' }}>
        <Form.Item className="pointer selector-input" name="conditionType">
          <Select
            className="select-input-field type-select-field"
            placeholder="Select"
            optionLabelProp="label"
            onChange={hanldeChange}
            options={[
              {
                value: 'event-registration',
                label: 'Event registration',
              },
              {
                value: 'event-first-date',
                label: 'Event First date',
              },
              {
                value: 'event-last-date',
                label: 'Event last date',
              },
              {
                value: 'ticket-first-date',
                label: 'Ticket Start date',
              },
              {
                value: 'ticket-last-date',
                label: 'Ticket last date',
              },
              {
                value: 'checked-in',
                label: 'Check-in',
              },
              {
                value: 'checked-out',
                label: 'Check-Out',
              },
              {
                value: 'customTimeToSend',
                label: 'Custom Time',
              },
            ]}
          />
        </Form.Item>
      </div>
    </div>
  )
}

export default CustomTime
